import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CourseService } from '@app/core/services/course.service';
import { SHARED_MODULES } from '@app/shared';
import { ModalAddTrailService } from '../modal-add-trail.service';
import { getStyleTextIcon, mapTypeToIcon } from '@app/modules/learning-trails/utils/type-mapper';
import { safeEmpty } from '@app/shared/utils';

@Component({
  selector: 'app-card-trail',
  imports: [SHARED_MODULES],
  templateUrl: './card-trail.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardTrailComponent {
  private readonly courseService = inject(CourseService);
  private readonly modalAddTrailService = inject(ModalAddTrailService);
  @Input() public trail: any;
  public typeIcon = mapTypeToIcon;
  public typeText = getStyleTextIcon;

  public get isTrailSelected(): boolean {
    return this.modalAddTrailService.isTrailSelected(this.trail);
  }

  public isElementSelected(element: any): boolean {
    return this.modalAddTrailService.isElementSelected(element);
  }

  public onSelectTrail(event: any) {
    event.stopPropagation();
    this.modalAddTrailService.selectTrail(this.trail, event.target.checked);
  }

  public onSelectElement(element: any, event: any) {
    event.stopPropagation();
    this.modalAddTrailService.selectElement(element, event.target.checked);
  }

  public onSetContent(element: any, event: any) {
    event.stopPropagation();
    this.modalAddTrailService.elementSelected$ = undefined;

    this.courseService
      .getElementByVitrine(this.trail.slug, element.slug)
      .pipe(safeEmpty())
      .subscribe((data) => (this.modalAddTrailService.elementSelected$ = data));
  }
}
